<table class="table table-hover table-responsive-md refund-table transactions-table">
    @if (sortDropdownOptions.length > 0) {
        <caption class="sort-field-md">
            <p-select [options]="sortDropdownOptions"
                      [ngModel]="activeSortField"
                      (onChange)="onSortFieldChange($event.value)"
                      class="sort-field"
                      optionLabel="name"
                      optionValue="id"
                      placeholder=" Sort by:"></p-select>
            <button type="button"
                    class="sort-direction-btn"
                    (click)="onSortDirectionToggle()"
                    aria-label="Toggle sort direction">
                <em [class]="sortClass(activeSortField ?? '')" aria-hidden="true"></em>
            </button>
        </caption>
    }
    <thead>
    <tr>
        <th scope="col" [attr.aria-sort]="ariaSort('dateTimeCreated')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('dateTimeCreated')"
                    (click)="onSort('dateTimeCreated')">
                Date Created <em [class]="sortClass('dateTimeCreated')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col">Account Number</th>
        <th scope="col">Name</th>
        <th scope="col">Reference</th>
        <th scope="col">Store</th>
        <th scope="col" [attr.aria-sort]="ariaSort('amount')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('amount')"
                    (click)="onSort('amount')">
                Amount <em [class]="sortClass('amount')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col">Order</th>
        <th scope="col">Status</th>
        <th scope="col" [attr.aria-sort]="ariaSort('completedAt')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('completedAt')"
                    (click)="onSort('completedAt')">
                Date Completed <em [class]="sortClass('completedAt')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col">Description</th>
        @if (showActions) {
            <th scope="col"></th>
        }
    </tr>
    </thead>
    <tbody class="table-hover text-nowrap">
        @if (loading) {
            <tr>
                <td class="text-center" [attr.colspan]="showActions ? 11 : 10">{{ loadingText }}</td>
            </tr>
        } @else if (error) {
            <tr>
                <td class="text-center data-unavailable"
                    [attr.colspan]="showActions ? 11 : 10">{{ errorText }}</td>
            </tr>
        } @else {
            @for (row of displayedRows; track trackRowKey(row.refund?.id, $index)) {
                <tr (click)="onRowClick(row)" [class.cursor-pointer]="clickable" class="active-color">
                    <td>
                        <span class="p-column-title">Date Created</span>
                        {{ row.refund?.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                    </td>
                    <td>
                        <span class="p-column-title">Account Number</span>
                        {{ row.accountNumber ?? '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Name</span>
                        {{ row.customer ?? '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Reference</span>
                        {{ row.referenceNumber ?? '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Store</span>
                        {{ row.storeName ?? '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Amount</span>
                        {{ row.refund?.amount | toMajor | currency: 'R ' }}
                    </td>
                    <td>
                        <span class="p-column-title">Order</span>
                        {{ row.orderNumber ?? '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Status</span>
                        <span [class]="statusClass(row)">{{ statusLabel(row) }}</span>
                    </td>
                    <td>
                        <span class="p-column-title">Date Completed</span>
                        @if (row.refund?.completedAt) {
                            {{ row.refund?.completedAt | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                        } @else {
                            -
                        }
                    </td>
                    <td>
                        <span class="p-column-title">Description</span>
                        {{ row.refund?.description ?? '-' }}
                    </td>
                    @if (showActions) {
                        <td class="actions-cell">
                            <button type="button"
                                    #menu
                                    aria-label="Refund actions"
                                    (click)="openMenu($event, contextMenu, row)"
                                    [class.grey-circle-style]="isGuestAdminUser()"
                                    class="circle-style">
                                <i class="fa fa-solid fa-ellipsis-vertical fa-lg"></i>
                            </button>
                            <p-contextMenu #contextMenu
                                           [appendTo]="'body'"
                                           [model]="activeMenuItems"
                                           [target]="menu"
                                           class="custom-contextmenu">
                                <ng-template let-item pTemplate="item">
                                    <a class="flex align-items-center p-menuitem-link custom-menu-item" pRipple>
                                        <i [class]="item.icon + ' menu-item-icon'"></i>
                                        <span class="ml-2 menu-item-text">{{ item.label }}</span>
                                    </a>
                                </ng-template>
                            </p-contextMenu>
                        </td>
                    }
                </tr>
                @if (isExpanded(row) && expandedRowTemplate) {
                    <tr class="expanded-row">
                        <ng-container *ngTemplateOutlet="expandedRowTemplate; context: {$implicit: row}"></ng-container>
                    </tr>
                }
            } @empty {
                <tr>
                    <td class="text-center" [attr.colspan]="showActions ? 11 : 10">{{ emptyText }}</td>
                </tr>
            }
        }
    </tbody>
</table>
